import React, { useState } from "react";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  DialogTitle,
  Dialog,
  DialogActions,
  Button,
  DialogContent,
  Stack,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Autocomplete,
} from "@material-ui/core";
import TimePicker from "@material-ui/lab/TimePicker";
import PersonIcon from "@material-ui/icons/Person";
import AddIcon from "@material-ui/icons/Add";
import { useSelector } from "react-redux";
import { LoadingButton } from "@material-ui/lab";
import { calendarioApi } from "src/services/calendarioApi";
import { empleadosApi } from "src/services/empleadosApi";
import { AlertaModalV2 } from "../AlertaSwall";
import { useSnackbar } from "src/components/snackbar";

export default function DialogAgregarActividad({ open, setOpen, fecha }) {
  const { empleado: user, sucursal: sucursalObtenida } = useSelector(
    (state) => state.auth.user,
  );
  const [empleados, setEmpleados] = useState([]);
  const [horaInicio, setHoraInicio] = useState(new Date());
  const [horaTermino, setHoraTermino] = useState(new Date());
  const { enqueueSnackbar } = useSnackbar();
  const [agregarCalendario] = calendarioApi.useAddCalendarioMutation();

  const [nombreEvento, setNombreEvento] = useState("");
  const [linkEvento, setLinkEvento] = useState("");
  const [urlArchivo, setUrlArchivo] = useState("");

  const [privado, setPrivado] = useState(true);

  const [empleado, setEmpleado] = useState(null);
  const [empleadoNombre, setEmpleadoNombre] = useState("");

  const { data: empleadosData = [] } = empleadosApi.useGetEmpleadosActivosQuery(
    {
      id: sucursalObtenida.refSucursal,
      estado: "TODOS",
    },
    {
      skip: !sucursalObtenida?.refSucursal,
    },
  );

  const handleClose = () => {
    setOpen(false);
  };

  const crearDato = async () => {
    if (
      nombreEvento === "" ||
      !horaInicio ||
      !horaTermino ||
      String(nombreEvento).length > 100
    ) {
      enqueueSnackbar(
        "Los siguientes datos son obligatorios: nombre del evento, hora de inicio y hora de término.",
        {
          variant: "info",
        },
      );
      return;
    }
    const horaInicioAux = new Date(horaInicio);
    const horaTerminoAux = new Date(horaTermino);
    const empleadoAux = [];

    empleados.forEach((item) => {
      empleadoAux.push(item.rut);
    });
    const body = {
      nombreCita: nombreEvento,
      link: linkEvento,
      urlArchivo: urlArchivo,
      fecha: fecha,
      privado: privado,
      refEmpleado: user.rut,
      refSucursal: sucursalObtenida.refSucursal,
      horaInicio: `${horaInicioAux.getHours()}:${horaInicioAux.getMinutes()}`,
      horaTermino: `${horaTerminoAux.getHours()}:${horaTerminoAux.getMinutes()}`,
      empleados: empleadoAux,
    };

    const result = await AlertaModalV2({
      title: "¿Agregar el evento?",
      confirmButtonText: "Sí, agregar",
    }).fire();
    if (!result.isConfirmed) return;

    try {
      await agregarCalendario(body).unwrap();
      enqueueSnackbar("Evento creado correctamente.", {
        variant: "success",
      });
      handleClose();
    } catch {
      enqueueSnackbar(
        "Ocurrió un error en el servidor. Inténtelo nuevamente más tarde.",
        {
          variant: "error",
        },
      );
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm" id="dialogNuevoEvento">
      <DialogTitle>Nuevo Evento</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <TextField
            style={{ marginTop: "10px" }}
            value={nombreEvento}
            onChange={(e) => setNombreEvento(e.target.value)}
            label="Nombre Cita"
            helperText="Máximo 100 caracteres"
            required
          />

          <TextField
            value={linkEvento}
            onChange={(e) => setLinkEvento(e.target.value)}
            label="Enlace de reunión (Zoom, Teams, etc.)"
            helperText="URL opcional para videoconferencia"
            color="info"
          />
          <TextField
            value={urlArchivo}
            onChange={(e) => setUrlArchivo(e.target.value)}
            label="Enlace a documento"
            helperText="URL de archivo compartido (opcional)"
            color="info"
          />

          <FormControl>
            <FormLabel id="radio-button-privado" focused={false}>
              ¿Visible para otros empleados?
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="radio-button-privado"
              value={privado}
              onChange={(e) => {
                let valorPrivado = e.target.value;
                setPrivado(valorPrivado === "true");
              }}
            >
              <FormControlLabel value={false} control={<Radio />} label="Sí" />
              <FormControlLabel value={true} control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>

          <TimePicker
            disablePast
            label="Seleccione Hora de Inicio"
            value={horaInicio}
            onChange={(newValue) => {
              setHoraInicio(newValue);
            }}
            renderInput={(params) => (
              <TextField required {...params} helperText={null} />
            )}
          />
          <TimePicker
            disablePast
            label="Seleccione Hora de Término"
            value={horaTermino}
            onChange={(newValue) => {
              setHoraTermino(newValue);
            }}
            renderInput={(params) => (
              <TextField required {...params} helperText={null} />
            )}
          />
        </Stack>

        <Grid container marginTop={10}>
          <Grid item xs={10} md={10}>
            <Autocomplete
              value={empleado}
              options={empleadosData}
              isOptionEqualToValue={(option, value) => option.rut === value.rut}
              getOptionLabel={(option) =>
                `${option.nombre} ${option.apellidos}`
              }
              onChange={(event, newValue) => {
                setEmpleado(newValue);
              }}
              inputValue={empleadoNombre}
              onInputChange={(event, newInputValue) => {
                setEmpleadoNombre(newInputValue);
              }}
              fullWidth
              ListboxProps={{ style: { maxHeight: "15rem" } }}
              renderInput={(params) => (
                <TextField {...params} label="Seleccione Participantes" />
              )}
            />
          </Grid>
          <Grid item xs={2} md={2}>
            <Button
              fullWidth
              style={{ marginTop: "10px" }}
              onClick={() => {
                if (!empleado) {
                  enqueueSnackbar(
                    "Debe seleccionar un participante de la lista.",
                    {
                      variant: "error",
                    },
                  );
                  return;
                }
                const existeEmpleado = empleados.filter(
                  (e) => e.rut === empleado.rut,
                )[0];
                if (existeEmpleado) {
                  setEmpleado(null);
                  setEmpleadoNombre("");
                  enqueueSnackbar(
                    "No es posible agregar la persona porque ya fue ingresada.",
                    {
                      variant: "error",
                    },
                  );
                } else {
                  setEmpleados([...empleados, empleado]);
                  setEmpleadoNombre("");
                  setEmpleado(null);
                }
              }}
            >
              <AddIcon />
            </Button>
          </Grid>
        </Grid>

        <List sx={{ pt: 0 }}>
          {empleados.map((item, idx) => (
            <ListItem key={`empleadosAsociados_${idx}`}>
              <ListItemAvatar>
                <Avatar>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={`${item.nombre} ${item.apellidos}`} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cerrar</Button>
        <LoadingButton onClick={crearDato} autoFocus>
          Guardar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
